import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './ReturnResponse.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

import { Svg_Cheked, Svg_ChekedReturn, Svg_Close, Svg_Home_1, Svg_LogoTipo } from "../../Svg";

interface ReturnResponseData {
    title         : string;
    text          : string;
    page          : string;
    name_project? : string;
    logo?         : string;
    link_project? : string;
}

export default function PopUp_ReturnResponse() {

    const [ modalData, setModaldata ] = useState<ReturnResponseData>({} as ReturnResponseData);
    const [ showPopUp, setShowPopUp ] = useState(false);

    function ClosePopUp(){
        SetModalState('ReturnResponse', false);
    }

    useEffect(()=>{
        RegisterModalData('ReturnResponse', setModaldata);
        RegisterModalObserver('ReturnResponse', setShowPopUp);
    }, []);

    if(!showPopUp){
        return <React.Fragment></React.Fragment>;
    }

    // Retorno do cadastro de projeto: card de sucesso com o logo do projeto
    if(modalData.page === 'project_saved'){
        return(
            <div className="PopUp PopUpCenter">
                <div className="all ReturnResponse project_saved">
                    <div className="close_popup" onClick={ ClosePopUp }>
                        <Svg_Close className="icons" color="#B1B2B2" />
                    </div>
                    <div className="content">
                        <div className="div_logo">
                            <Svg_LogoTipo className="icons logo" />
                        </div>
                        <div className="div_type_return">
                            <Svg_Cheked className="icons cheked" color="#27AE60" />
                            <div className="">Success</div>
                        </div>
                        <div className="logo_project">
                            <img alt="logo" src={ modalData.logo ? modalData.logo : "./assets/logo.png" } />
                        </div>
                        <div className="msg">
                            <div className="title">{ modalData.name_project }</div>
                        </div>
                        <div className="btn" onClick={ ()=>{ window.open(modalData.link_project, "_blank", "noopener,noreferrer") } }>
                            <Svg_Home_1 className="icons" color="#B1B2B2" />
                            <div className="">Home</div>
                        </div>
                    </div>
                </div>
                <div className="close_all" onClick={ ClosePopUp } />
            </div>
        )
    }

    return(
        <div className="PopUp PopUpCenter">
            <div className="all ReturnResponse">
                <div className="div_title">
                    <div className="">{ modalData.title }</div>
                    <div className="close" onClick={ ClosePopUp }>
                        <Svg_Close className="icons" color="#B1B2B2" />
                    </div>
                </div>
                <div className="div_text">
                    <div className="div_icon">
                        {
                            modalData.page === 'error' ?
                                <div className="icon_error">!</div>
                            :
                            <div className="icon_ok">
                                <Svg_ChekedReturn className="" color="#EDA13F" />
                            </div>
                        }
                    </div>
                    <div className="show_text">
                        { modalData.text }
                    </div>
                </div>
            </div>
            <div className="close_all" onClick={ ClosePopUp } />
        </div>
    )
}
